import {
  SENDPINBYEMAIL_SUCCESS,
  SENDPINBYEMAIL_FAILED,
  SENDPINBYEMAIL_INVALID_REQUEST,
  LOADING_SENDPINBYEMAIL,
  SENDPINBYEMAIL_NOTFOUND,
  RESET_SENDPINBYEMAIL
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  success: false,
  networkError: "",
  status: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_SENDPINBYEMAIL:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        notFound: false,
        success: false,
        networkError: "",
        status: {}
      };
    case SENDPINBYEMAIL_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: false,
        failed: true,
        networkError: "",
        status: action.payload.status
      };

    case SENDPINBYEMAIL_NOTFOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: true,
        failed: false,
        networkError: "",
        status: action.payload.status
      };
    case SENDPINBYEMAIL_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        notFound: false,
        failed: false,
        networkError: "",
        status: action.payload.status
      };
    case SENDPINBYEMAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        notFound: false,
        networkError: "",
        status: action.payload.status
      };

    case RESET_SENDPINBYEMAIL:
      return (state = initialState);

    default:
      return state;
  }
};
